import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import scss from './LoginOrRegisterBtn.module.scss';
export const LoginOrRegisterBtn = () => {
    const { t } = useTranslation();
    return (_jsx("button", Object.assign({ className: scss.loginOrRegisterBtn, type: "button" }, { children: t('loginOrRegister') })));
};
